import {createContext} from '@lit-labs/context';

export interface ScrubList {
  email_list_id: string;
  email_list_name: string;
  reporting_category: string;
  team_id: string;
}

export const ScrubListContext =
  createContext<ScrubList[]>('scrub-list-context');
